import {APIPromise, easasAxios, paramsSerializer, requestPromiseTypeWrapper} from "../services/HttpService";
import {AxiosInstance, AxiosRequestConfig} from 'axios'
import {getEasasRestUrl} from "../utils/utils";

export abstract class ApiDefinition {
    protected static promise = requestPromiseTypeWrapper;
    protected apiScopeUrl: string;
    protected httpClient: AxiosInstance;
    protected constructor(apiScopeUrl: string) {
        this.httpClient = easasAxios;
        this.apiScopeUrl = apiScopeUrl;

        console.debug(`ApiDefinition (${apiScopeUrl}) obj created!`)
    }

    async get<T>(url: string, config?: AxiosRequestConfig): APIPromise<T> {
        return ApiDefinition.promise(this.httpClient.get(this.formatUrl(url), config));
    }

    async post<T, D>(url: string | null, data?: D, config?: AxiosRequestConfig<D>): APIPromise<T> {
        return ApiDefinition.promise(this.httpClient.post(this.formatUrl(url), data, config));
    }

    async put<T, D>(url: string | null, data?: D, config?: AxiosRequestConfig<D>): APIPromise<T> {
        return ApiDefinition.promise(this.httpClient.put(this.formatUrl(url), data, config));
    }

    async patch<T, D>(url: string | null, data?: D, config?: AxiosRequestConfig<D>): APIPromise<T> {
        return ApiDefinition.promise(this.httpClient.patch(this.formatUrl(url), data, config));
    }

    async delete<T>(url: string, config?: AxiosRequestConfig): APIPromise<T> {
        return ApiDefinition.promise(this.httpClient.delete(this.formatUrl(url), config));
    }

    private formatUrl(url: string | null): string {
        if(url != null) {
            return this.apiScopeUrl + "/" + url
        }

        return this.apiScopeUrl;
    }

    protected getFullUrl(url: string | null, params?: any): string {
        return getEasasRestUrl() + this.formatUrl(url) + (params ? "?" + paramsSerializer(params) : "");
    }
}
